module.exports = __webpack_public_path__ + "img/share_icon.0b7fdbe0.svg";